import { render, staticRenderFns } from "./OrgBadge.vue?vue&type=template&id=6e535eb2"
import script from "./OrgBadge.vue?vue&type=script&lang=js"
export * from "./OrgBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports